// extracted by mini-css-extract-plugin
export default {"errorMessage":"error-message__errorMessage___3gtJe","errorMessageIcon":"error-message__errorMessageIcon___1Ur4b"};